import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function OpenIssuesDialog({ open, onClose, officers, issuesByOfficer }) {
  const sortedOfficers = [...issuesByOfficer].sort((a, b) => b.total - a.total);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="dash-openissuesdialog-dialog" className="bg-slate-900 border-slate-800 text-slate-100 max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-slate-100">Open Issues by Officer</DialogTitle>
        </DialogHeader>
        
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800">
              <TableHead className="text-slate-400">Officer</TableHead>
              <TableHead className="text-slate-400">Callsign</TableHead>
              <TableHead className="text-slate-400 text-right">Critical</TableHead>
              <TableHead className="text-slate-400 text-right">High</TableHead>
              <TableHead className="text-slate-400 text-right">Medium</TableHead>
              <TableHead className="text-slate-400 text-right">Low</TableHead>
              <TableHead className="text-slate-400 text-right">Total</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedOfficers.map((item) => {
              const officer = officers.find(o => o.user_email === item.email);
              return (
                <TableRow key={item.email} className="border-slate-800">
                  <TableCell className="text-slate-200">{officer?.user_email || item.email}</TableCell>
                  <TableCell className="text-slate-300">{officer?.callsign || 'N/A'}</TableCell>
                  <TableCell className="text-right">
                    <Badge className="bg-purple-500/20 text-purple-400 border-none">
                      {item.critical}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge className="bg-red-500/20 text-red-400 border-none">
                      {item.high}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge className="bg-amber-500/20 text-amber-400 border-none">
                      {item.medium}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge className="bg-slate-500/20 text-slate-400 border-none">
                      {item.low}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge className="bg-rose-500/20 text-rose-400 border-none">
                      {item.total}
                    </Badge>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
}